import { types } from 'mobx-state-tree';

const PolicyList = types.model({
  effectiveDate: types.maybeNull(types.string),
  endDate: types.maybeNull(types.string),
  fullTermPolicyEndDate: types.maybeNull(types.string),
  fullTermCancel: types.maybeNull(types.boolean),
  fees: types.array(types.frozen()),
  fromStaff: types.maybeNull(types.boolean),
  id: types.string,
  source: types.maybeNull(types.string),
  importedData: types.maybeNull(types.frozen()),
  webUserId: types.maybeNull(types.string),
  offer: types.maybeNull(types.frozen()),
  paymentMethod: types.maybeNull(types.string),
  paymentMode: types.maybeNull(types.string),
  paymentType: types.maybeNull(types.string),
  billingDayOfMonth: types.maybeNull(types.number),
  policyDetails: types.maybeNull(types.frozen()),
  policyType: types.maybeNull(types.string),
  premium: types.maybeNull(types.number),
  segments: types.array(types.frozen()),
  state: types.maybeNull(types.string),
  stripeCustomerId: types.maybeNull(types.string),
  surplusContribution: types.maybeNull(types.number),
  versionHistory: types.array(types.frozen()),
  salesRep: types.maybeNull(types.string),
  bindRep: types.maybeNull(types.string),
  term: types.maybeNull(types.number),
  isAgentSold: types.maybeNull(types.boolean),
  branchPlusLinkedOfferId: types.maybeNull(types.string),
  // #33509: needed so the farm migration relaxations can detect a migrated lineage from the account's
  // term list (the flag lives on the renewal, not the surfaced in-force imported term). MST strips
  // undeclared fields, so omitting this made every list entry read undefined and defeated the check.
  wasRenewedFromImportedTerm: types.maybeNull(types.boolean),
  // #36661: the policy-page "rewritten" prompt follows this through the list to the newest rewrite.
  rewrittenToPolicyId: types.maybeNull(types.string)
});

export default PolicyList;
